<template>
  <v-container>
    <div class="containerStyle" v-if="loader">
      <img id="loader" class="zoom" :src="img2" />
    </div>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="containerStyle2" md10 lg10 xs12 sm11 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Fortalezas y Debilidades {{this.$session.getAll().ccData.nombre}}</h4>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table id="table2" class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th style class="col-md-10 col-lg-10 col-sm-10 col-xs-10">Fortalezas</th>
                    <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Editar</th>
                    <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Borrar</th>
                  </tr>
                </thead>
                <tbody class="table2">
                  <tr v-for="(item,index) in fortalezas" :key="index">
                    <td style="text-align:left " class="col-md-10 col-lg-10 col-sm-10 col-xs-10">{{item.descripcion}}</td>
                    <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                      <v-icon :disabled="($session.getAll().puedeEditar != true)" small class="mr-2" @click="openEditFortaleza(item,index)">edit</v-icon>
                    </td>
                    <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                      <v-icon :disabled="($session.getAll().puedeEditar != true)" small class="mr-2" @click="deleteFD(item)">delete</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed table2">
                <thead>
                  <tr>
                    <th style class="col-md-10 col-lg-10 col-sm-10 col-xs-10">Debilidades</th>
                    <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Editar</th>
                    <th style="text-align:left " class="col-md-1 col-lg-1 col-sm-1 col-xs-1">Borrar</th>
                  </tr>
                </thead>
                <tbody class="table2">
                  <tr v-for="(item,index) in debilidades" :key="index">
                    <td style="text-align:left " class="col-md-10 col-lg-10 col-sm-10 col0-xs-10">{{item.descripcion}}</td>
                    <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                      <v-icon :disabled="($session.getAll().puedeEditar != true)" small class="mr-2" @click="openEditDebilidad(item,index)">edit</v-icon>
                    </td>
                    <td class="col-md-1 col-lg-1 col-sm-1 col-xs-1">
                      <v-icon :disabled="($session.getAll().puedeEditar != true)" small class="mr-2" @click="deleteFD(item)">delete</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>

      <!--<v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FGu%C3%ADa%20Metodol%C3%B3gica%20Criterios.pdf?alt=media&token=cebfbe5a-f0d6-4452-878a-e1b099d58e23"
                        target="_blank"
                      >Guía metodológica</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FPerfil%20de%20Egreso%20y%20Plan%20de%20Estudios.pdf?alt=media&token=71ef8f1f-d5ff-4ae6-a81d-3e132d17c01c"
                        target="_blank"
                      >Perfil de egreso</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FResoluciones.pdf?alt=media&token=8f9c6939-40ae-47ac-bd74-51ec9f65dc64"
                        target="_blank"
                      >Resoluciones</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FReporte%20UNIE.pdf?alt=media&token=dfae1761-f737-4fe5-834e-2dd07aebf67e"
                        target="_blank"
                      >Reporte Unie</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FEstudios%20de%20Opini%C3%B3n.pdf?alt=media&token=141e0130-7a22-4214-97c9-879093332302"
                        target="_blank"
                      >Estudios de opinión</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FIndicadores.xlsx?alt=media&token=6a8fb8ab-17ff-438c-a5fc-1b1814fa907f"
                        target="_blank"
                      >Indicadores</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        small
                        color="#EB7704"
                        class="button"
                        href="https://firebasestorage.googleapis.com/v0/b/fir-3de9d.appspot.com/o/E2%2FIndicadores.xlsx?alt=media&token=6a8fb8ab-17ff-438c-a5fc-1b1814fa907f"
                        target="_blank"
                      >Evidencia</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="img3" class="image" @click="asistencia = true" />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-dialog v-model="asistencia" width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <v-card-title>
                <span class="headline">Asistencia DCA</span>
              </v-card-title>
              <div class="form-group">
                <label for="comment">Comenta tus inquietudes</label>
                <textarea class="form-control" rows="9" id="comment"></textarea>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#ec6a12" flat="flat" @click="asistencia = false">Cerrar</v-btn>
                <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>-->
    </v-layout>
    <v-layout row>

    </v-layout>
    <v-layout>
      <v-dialog v-model="editFortaleza" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar Fortaleza</span>
            <span class="headline" v-if="create">Crear Fortaleza</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Fortaleza</label>
                <textarea
                  v-model="fortaleza.descripcion"
                  type="text"
                  rows="6"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="editFortaleza = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editFortalezaF()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createFortaleza()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="editDebilidad" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar Debilidad</span>
            <span class="headline" v-if="create">Crear Debilidad</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Debilidad</label>
                <textarea
                  v-model="debilidad.descripcion"
                  type="text"
                  rows="6"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="editDebilidad = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editDebilidadF()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createDebilidad()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_6.png";
import img2 from "../../../assets/LOGO USACH.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
export default {
  data() {
    return {
      img2: img2,
      loader: true,
      editFortaleza: false,
      editDebilidad: false,
      fortalezas: "",
      fortaleza: "",
      debilidades: "",
      debilidad: "",
      img3: img3,
      asistencia: false,
      create: false,
      edit: false,
      index: "",
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1
    };
  },
  created() {
    this.getFyd();
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },
    deleteFD(item) {
      //console.log(item.id);
      axios
        .delete(
          process.env.ROOT_API + "/fyd/delete?idFyD=" + item.id,
          this.auth
        )
        .then(response => {
          this.getFyd();
          alert(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    },
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          "http://localhost:8089/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },
    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    openEditFortaleza(fortaleza, index) {
      this.create = false;
      this.editFortaleza = true;
      this.index = index;
      this.fortaleza = fortaleza;
    },
    openEditDebilidad(debilidad, index) {
      this.create = false;
      this.editDebilidad = true;
      this.index = index;
      this.debilidad = debilidad;
    },
    opencreateFortaleza() {
      this.create = true;
      this.editFortaleza = true;
      this.fortaleza = {
        descripcion: "",
        tipo: "Fortaleza"
      };
    },
    opencreateDebilidad() {
      this.create = true;
      this.editDebilidad = true;
      this.debilidad = {
        descripcion: "",
        tipo: "Debilidad"
      };
    },
    editFortalezaF() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    editDebilidadF() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    createFortaleza() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidadPostgrado?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    createDebilidad() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidadPostgrado?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },
    getFyd() {
      axios
        .get(
          process.env.ROOT_API +
            "/fyd/getAllByPostgrado?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.fortalezas = response.data[0];
          this.debilidades = response.data[1];
          this.loader = false
        })
        .catch(error => {
          console.error(error);
          this.loader = false
          alert("Error:" + error);
        });
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}
.titlep {
  color: #ec6a12;
  font-size: 12px;
}
.table2 {
  height: 145px !important;
}
.v-card-new {
  margin-bottom: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 120px !important;
  overflow-y: auto;
}
.v-card {
  height: auto;
  overflow-y: auto;
}
.td-color {
  background: #394049;
  height: 100%;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}
.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}
.drawner2 {
  width: 100% !important;
  height: 250px !important;
  text-decoration: none !important;
  background-color: #394049 !important;
}
.font {
  color: white !important;
}
.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}
.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}
.text-vision {
  color: white;
  font-size: 12px;
}
.pull {
  text-align: justify;
}
.v-list-new {
  height: 100% !important;
}
.v-btn__content {
  font-size: 10px !important;
}
.theme--light.v-btn {
  color: white;
}
.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}
.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}
.th {
  background-color: aqua !important;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/evaluacion/D1Post.vue